module.exports = __webpack_public_path__ + "images/SmileDirectClub-b76352.png";